import config from './config';
import _ from 'lodash';

const configHandler = () => {
  // First try to use webpack-injected environment variables (production/QA)
  if (process.env.EXTERNAL_OAUTH_KEY) {
    const output = {
      EXTERNAL_OAUTH_KEY: process.env.EXTERNAL_OAUTH_KEY,
      EXTERNAL_OAUTH_URL: process.env.EXTERNAL_OAUTH_URL,
      EXTERNAL_AGENCY_API_SCOPE: process.env.EXTERNAL_AGENCY_API_SCOPE,
      TAXONLINE_ENVIRONMENT: process.env.TAXONLINE_ENVIRONMENT,
      TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL: process.env.TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL,
      TAXONLINE_SME_DASHBOARD_URL: process.env.TAXONLINE_SME_DASHBOARD_URL,
      TAXONLINE_PUBLIC_API_URL: process.env.TAXONLINE_PUBLIC_API_URL,
    };
    return output;
  }
  // Fallback to window.MYOB if available (legacy support)
  else if (_.get(window, 'MYOB.taxonline.config')) {
    return window.MYOB.taxonline.config;
  } 
  // Fallback to local config (development)
  else {
    const environment = config.env[window.location.hostname];
    const output = {
      EXTERNAL_OAUTH_KEY: config.clientId[environment],
      EXTERNAL_OAUTH_URL: config.authUri[environment],
      EXTERNAL_AGENCY_API_SCOPE: "auskey.read auskey.write",
      TAXONLINE_ENVIRONMENT: "dev",
      TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL: config.redirectUri[environment],
      TAXONLINE_SME_DASHBOARD_URL: config.smeDashboardUri[environment],
      TAXONLINE_PUBLIC_API_URL: config.publicApiUri[environment],
    };
    return output;
  }
};

export default configHandler;


// WEBPACK FOOTER //
// ./src/app/configHandler.js